export default {
  comingSoon: {
    title: "New listing report coming soon.",
    text: "See your listing's performance, engagement and how it compares to other properties on the market. Take advantage of this new feature soon.",
  },
  nullListingData: {
    title: "Sorry, something went wrong.",
    text: "Please speak with your office administration.",
  },
  tooltip: {
    dateRange: "Data is updated daily at 11am.",
  },
  reporting: {
    common: {
      byProduct: "By product",
      standard: "Standard",
      feature: "Feature",
      featureMY: "Featured",
      premium: "Premium",
      tabName: {
        impressions: "Impressions",
        pageViews: "Page views",
        enquiries: "Enquiries",
      },
    },
    tooltip: {
      pro: {
        title: "Listing Insight",
        content: "The Listing Insight you see here is from iProperty Pro.",
      },
      agentNet: {
        title: "AgentNet Listing Insight",
        content:
          "You can now easily view your AgentNet Listing insight with the link here.",
      },
    },
  },
  durationButton: {
    oneWeek: "1W",
    oneMonth: "1M",
    threeMonth: "3M",
    sevenDays: "7D",
    thirtyDays: "30D",
  },
  listingPerformance: {
    title: "Listing Performance",
    description: "By marketing effort from product upgrades used.",
    impressions: {
      header: "Total Impression",
      showSources: "Show Sources",
      hideSources: "Hide Sources",
      state: "State",
      city: "City",
      building: "Building",
      other: "Other",
    },
    pageViews: {
      header: "Total Page views",
      mobileApp: "Mobile App",
      mobileWeb: "Mobile Web",
      desktop: "Desktop",
      showSources: "Show Traffic Sources",
      hideSources: "Hide Traffic Sources",
    },
    enquiries: {
      header: "Total Enquiries",
      phone: "Phone Number Reveal",
      whatsapp: "WhatsApp",
      email: "Email",
      showBreakdown: "Show Enquiries Breakdown",
      hideBreakdown: "Hide Enquiries Breakdown",
      chartTitle: "Enquiries <br/> Breakdown",
    },
  },
  engagement: {
    title: "Engagement",
    description: "How consumers interact with your listing.",
    saved: "Saved Listing",
    download: "Download PDF",
    view: "View Photos",
    share: "Social Share",
    where: "Where is it being share to? ",
    breakdown: "Social Share Breakdown",
    viewVideo: "View Videos",
    view360: "View 360",
    viewFloorPlan: "View Floor Plan",
  },
  listingTimeline: {
    title: "Listing Timeline",
    legend: {
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      peak: "Peak",
      standard: "Standard days",
      feature: "Feature days",
      featureMY: "Featured days",
      premium: "Premium days",
    },
    tooltip: {
      impressions:
        '<b style="font-family: Mulish, Inter, sans-serif; font-size: 1.4rem;">{impressions}</b> impressions',
      pageViews:
        '<b style="font-family: Mulish, Inter, sans-serif; font-size: 1.4rem;">{impressions}</b> page views',
      enquiries:
        '<b style="font-family: Mulish, Inter, sans-serif; font-size: 1.4rem;">{impressions}</b> enquiries',
    },
  },
  marketComparison: {
    title: "Market Comparison",
    description:
      "Listing is required to be active for minimum {duration, plural, =0{1 week} =1{1 month} other{3 months}} to do Market Comparison.",
    builtUp: "Saleable area",
    land: "Gross area",
    builtUpArea: "Built up area",
    landArea: "Land area",
    yourListing: "Your Listing",
    districtAvg: "District Avg.",
    estateAvg: "Estate Avg.",
    cityAvg: "City Avg.",
    buildingAvg: "Building Avg.",
    sqft: "sq.ft.",
    measurement: "{measurement, plural, =0{} =1{sq.ft} other {acres}}",
    compareTextMY:
      "Compare {selectedTab, plural, =0{impressions} =1{page views} other{enquiries}} based on <strong>{buildUpOrLand, plural, =0{built up area} =1{land area} other{}}</strong> {comparison, plural, =0 {all listings} other{within the range provided}}",
    compareText:
      "Compare {selectedTab, plural, =0{impressions} =1{page views} other{enquiries}} based on <strong>{buildUpOrLand, plural, =0{saleable area} =1{gross area} other{}}</strong> {comparison, plural, =0 {all listings} other{within the range provided}}",
    cityPercentageTextHighMY:
      'Your listing has <span style="color: #04a079">{cityPercentage} higher</span> {selectedTab, plural, =0{impressions} =1{page views} other{enquiries}} compared to {comparison, plural, =0 {all} other{other}} listings in the city ',
    cityPercentageTextLowMY:
      'Your listing has <span style="color: #c20114">{cityPercentage} lower</span> {selectedTab, plural, =0{impressions} =1{page views} other{enquiries}} compared to {comparison, plural, =0 {all} other{other}} listings in the city ',
    buildingPercentageTextHighMY: `and <span style="color: #04a079">{buildingPercentage} higher</span> than {comparison, plural, =0 {all} other{others}} in the building`,
    buildingPercentageTextLowMY: `and <span style="color: #c20114">{buildingPercentage} lower</span> than {comparison, plural, =0 {all} other{others}} in the building`,
    percentageTextHigh:
      'Your listing has <span style="color: #04a079">{percentage} higher</span> {selectedTab, plural, =0{impressions} =1{page views} other{enquiries}} compared to {comparison, plural, =0 {all} other{other}} listings in the district.',
    percentageTextLow:
      'Your listing has <span style="color: #c20114">{percentage} lower</span> {selectedTab, plural, =0{impressions} =1{page views} other{enquiries}} compared to {comparison, plural, =0 {all} other{other}} listings in the district.',
  },
  agentNet: {
    listingPerformance: {
      title: "Listing Performance",
      description: "How your listing performs over time",
      views: "Views",
      leads: "Leads",
      impression: "Impressions",
      from: "from {days, plural, =30{last month} other{last week}}",
    },
    leads: {
      title: "How Your Potential Clients Contact You?",
      allLeads: "All Leads",
      whatsapp: "Whatsapp",
      calls: "Calls",
      sms: "SMS",
      messages: "Messages",
      phoneReveals: "Phone Reveals",
      totalNumber: "Total number from {days} days",
    },
    engagement: {
      title: "See What They are Clicking On Your Listing",
      allEngagements: "All Engagements",
      views: "Views",
      galleryActions: "Gallery Actions",
      priceInsights: "Price Insights",
      mapActions: "Location (Map Actions)",
      descriptionExpands: "Description Expands",
      saves: "Shortlist",
      shares: "Shares",
    },
  },
};
